<template>
  <div>
    <div class="d-flex justify-content-between mb-1">

      <b-button
        v-b-toggle.collapse-1
        variant="outline-primary"
      >
        {{ t('Filters') }}
      </b-button>

      <b-button
        variant="outline-primary"
        @click="exportToExcel"
      >
        {{ t('Export') }}
      </b-button>

    </div>

    <b-collapse
      id="collapse-1"
      class="mt-2"
    >
      <user-tracking-activity-report-filter
        :filterparams="form"
        @searchData="GetSearchFilter"
      />
    </b-collapse>
    <b-card>
      <b-table-simple
        id="ActivityTrackingReportTable"
        hover
        caption-top
        responsive
        class="rounded-bottom mb-0 table table-bordered"
      >
        <b-thead head-variant="light">
          <b-tr>
            <b-th>
              UserName
            </b-th>
            <b-th>
              New Client
            </b-th>
            <b-th>
              New Leads
            </b-th>
            <b-th>
              Converted to Opportunity
            </b-th>
            <b-th>
              Agreements Signed
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(item, index) in ActivityTrackingReport"
            :key="index"
          >
            <b-td>
              {{ item.username }}
            </b-td>
            <b-td>
              <template v-if="item.new_client > 0">
                <b-link :to="{ name: 'vendors/list-vendor' }">
                  {{ item.new_client }}
                </b-link>
              </template>
              <template v-else>
                {{ item.new_client }}
              </template>
            </b-td>
            <b-td>
              <template v-if="item.new_leads > 0">
                <b-link :to="{ name: 'leads/' }">
                  {{ item.new_leads }}
                </b-link>
              </template>
              <template v-else>
                {{ item.new_leads }}
              </template>
            </b-td>
            <b-td>
              <template v-if="item.revenue_on_boarded > 0">
                <b-link
                  :to="{
                    name: 'leads/lead-opportunity-list',
                    query: { status: 1008, start_date: form.start_date, end_date: form.end_date, }
                  }"
                >
                  {{ item.revenue_on_boarded }}
                </b-link>
              </template>
              <template v-else>
                {{ item.revenue_on_boarded }}
              </template>
            </b-td>
            <b-td>
              <template v-if="item.agreement_signed > 0">
                <b-link
                  :to="{
                    name: 'leads/lead-opportunity-list',
                    query: { status: 1007, start_date: form.start_date, end_date: form.end_date, }
                  }"
                >
                  {{ item.agreement_signed }}
                </b-link>
              </template>
              <template v-else>
                {{ item.agreement_signed }}
              </template>
            </b-td>
          </b-tr>
          <b-tr v-if="ActivityTrackingReport.length == 0">
            <b-td
              class="text-center"
              colspan="5"
            >
              Record Not Found.
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-card>
  </div>
</template>
<script>
import {
  BButton, BCard, BCollapse, VBToggle,
} from 'bootstrap-vue'
import { useUtils } from '@core/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import constants from '@/constants'
import UserTrackingActivityReportFilter from './UserTrackingActivityReportFilter.vue'
import { showLoader, hideLoader } from '@/utils/common'

export default {
  components: {
    BButton,
    BCard,
    BCollapse,
    UserTrackingActivityReportFilter,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      constants,
      form: {
        start_date: null,
        end_date: null,
      },
      ActivityTrackingReport: [],
      activityModalData: [],
      activityTrackingReportData: [],
      excelData: [],
    }
  },
  mounted() {

  },
  methods: {
    exportToExcel() {
      const htmltable = document.getElementById('ActivityTrackingReportTable')
      const html = htmltable.outerHTML
      window.open(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8, ${encodeURIComponent(html)}`)
    },
    GetSearchFilter(val) {
      this.form = val
      this.getUserTrackingActivityReport()
    },
    async getUserTrackingActivityReport() {
      showLoader()
      await store.dispatch('ReportStore/GetUserTrackingActivityReport', this.form).then(response => {
        if (response.data.code === constants.SUCCESS) {
          this.ActivityTrackingReport = response.data.data.rowData
          document.getElementById('loading-bg').classList.remove('loading-bg')
          // eslint-disable-next-line eqeqeq
        } else if (response.data.code == constants.ERROR_500) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Something Went Wrong!',
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        }
      }).catch(e => {
      // eslint-disable-next-line eqeqeq
        if (e.msg == 'Unauthenticated.') {
          this.$router.back()
          document.getElementById('loading-bg').classList.remove('loading-bg')
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'No Permission',
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Something Went Wrong!',
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        }
      })
      hideLoader()
    },
    openModal(event, type) {
      this.type = type
      this.ActivityTrackingReportData = []
      showLoader()
      this.$bvModal.show('activityModalData')
      store.dispatch('DashboardApi/GetFunnelLeadData',
        {
          type: this.type,
          user: event.companyuserid,
          start_date: this.form.start_date,
          end_date: this.form.end_date,
        }).then(async response => {
        if (response.data.code === constants.SUCCESS) {
          this.ActivityTrackingReportData = response.data.data
          hideLoader()
        }
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Something went wrong',
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
        hideLoader()
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
